export const GET_INVENTORY: string = 'GET_INVENTORY';
export const GET_INVENTORY_SUCCESS: string = 'GET_INVENTORY_SUCCESS';
export const GET_INVENTORY_ERROR: string = 'GET_INVENTORY_ERROR';
export const GET_INVENTORY_EXCEL: string = 'GET_INVENTORY_EXCEL';
export const GET_INVENTORY_EXCEL_SUCCESS: string = 'GET_INVENTORY_EXCEL_SUCCESS';
export const GET_INVENTORY_EXCEL_ERROR: string = 'GET_INVENTORY_EXCEL_ERROR';